import React from 'react'
import { ReactComponent as ArrowIcon } from 'assets/icons/arrow_short_right.svg'
import s from './styles/ExploreTools.module.scss'

export default function ExploreTools({ tools, onSelect }) {
	return (
		<>
			<section className={s.intro}>
				<div>
					<span className={s.eyebrow}>Counsellor research workspace</span>
					<h1 className={s.introTitle}>Explore AI Tools</h1>
				</div>
			</section>

			<section className={s.exploreSection}>
				<span className={s.sectionLabel}>Explore research tools</span>
				<div className={s.tools} aria-label="Research tools">
					{tools.map(tool => (
						<button
							key={tool.id}
							type="button"
							className={`${s.toolCard} ${!tool.enabled ? s.disabledTool : ''}`}
							onClick={() => tool.enabled && onSelect(tool.id)}
							aria-disabled={!tool.enabled}
						>
							<span className={s.toolHeader}>
								<span className={s.toolIcon}>{tool.icon}</span>
								<span className={s.toolTitle}>{tool.title}</span>
								{!tool.enabled && (
									<em className={s.toolSoonBadge}>SOON</em>
								)}
							</span>
							<span className={s.toolStats}>
								{tool.stats.map(stat => (
									<b key={stat} className={s.toolStat}>
										{stat}
									</b>
								))}
							</span>
							<span className={s.toolDescription}>{tool.description}</span>
							<span className={s.toolAction}>
								{tool.action}
								<ArrowIcon className={s.toolActionIcon} />
							</span>
						</button>
					))}
				</div>
			</section>
		</>
	)
}
